export var SSEEventPayloadType;
(function (SSEEventPayloadType) {
    SSEEventPayloadType["ASSISTANT_MESSAGE_CHUNK"] = "assistant_message_chunk";
    SSEEventPayloadType["ASSISTANT_STATUS"] = "assistant_status";
    SSEEventPayloadType["ASSISTANT_COMPLETE"] = "assistant_complete";
    SSEEventPayloadType["ASSISTANT_ERROR"] = "assistant_error";
    SSEEventPayloadType["ASSISTANT_WARNING"] = "assistant_warning";
    SSEEventPayloadType["ASSISTANT_REPLY_MODEL_FALLBACK"] = "assistant_reply_model_fallback";
    SSEEventPayloadType["ASSISTANT_TOOL_USE_START"] = "assistant_tool_use_start";
    SSEEventPayloadType["ASSISTANT_TOOL_PROGRESS"] = "assistant_tool_progress";
    SSEEventPayloadType["ASSISTANT_TOOL_RESULT"] = "assistant_tool_result";
    SSEEventPayloadType["ASSISTANT_TOOL_USE_END"] = "assistant_tool_use_end";
    SSEEventPayloadType["USER_MESSAGE_CREATED"] = "user_message_created";
    SSEEventPayloadType["CONVERSATION_TITLE_UPDATED"] = "conversation_title_updated";
})(SSEEventPayloadType || (SSEEventPayloadType = {}));
export const MODEL_FALLBACK_REASON_PROVIDER_ERROR = 'provider_error';
